import React from 'react'
import { useCallback } from 'react'

import { AuthResponse, store, switchProductForCompanyUser } from 'core'
import getLoginUser, { User } from 'core/application/account/loginUser'
import { ProductIds } from 'core/application/commons/config'

import useCommandRequest from './useCommandRequest'
import useLoginUser from './useLoginUser'
import useQueryRequest from './useQueryRequest'

const useSwitchProduct = (onSwitch: (user?: User) => void) => {
  const [, setLoginUser] = useLoginUser()
  const [sendCommand, loading] = useCommandRequest<AuthResponse>()
  const [, , sendGetLoginUser] = useQueryRequest(null)

  const handleSwitchProduct = useCallback(
    async (companyId: string, userProductId: number) => {
      const result = await sendCommand(() => switchProductForCompanyUser(companyId, userProductId))

      if (result.completed) {
        store.setToken(result.data.token)
        const user = await sendGetLoginUser(() => getLoginUser())
        if (user) {
          setLoginUser(user)
          store.setLastProductId(user.productId)
          onSwitch(user)
        }
      }
    },
    [onSwitch],
  )

  return { handleSwitchProduct, loading }
}

export default useSwitchProduct
